var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68595 1.83272C10.4523 1.41472 11.3866 1.96938 11.3866 2.8423V13.1578C11.3866 14.0307 10.4523 14.5853 9.68595 14.1673L3.23757 10.65H1.9C0.98873 10.65 0.25 9.91131 0.25 9.00004V7.00004C0.25 6.08877 0.98873 5.35004 1.9 5.35004H3.23753L9.68595 1.83272Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9109 4.26063C15.1352 4.54095 15.0897 4.94999 14.8094 5.17425L13.1427 6.50758C12.8624 6.73184 12.4534 6.68639 12.2291 6.40607C12.0049 6.12575 12.0503 5.71671 12.3306 5.49246L13.9973 4.15912C14.2776 3.93487 14.6867 3.98031 14.9109 4.26063Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4033 8.0167C12.4033 7.65771 12.6943 7.3667 13.0533 7.3667H15.0867C15.4456 7.3667 15.7367 7.65771 15.7367 8.0167C15.7367 8.37568 15.4456 8.6667 15.0867 8.6667H13.0533C12.6943 8.6667 12.4033 8.37568 12.4033 8.0167Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1427 9.82581C12.8624 9.60155 12.4534 9.647 12.2291 9.92732C12.0049 10.2076 12.0503 10.6167 12.3306 10.8409L13.9973 12.1743C14.2776 12.3985 14.6867 12.3531 14.9109 12.0728C15.1352 11.7924 15.0897 11.3834 14.8094 11.1591L13.1427 9.82581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingActive);
export default __webpack_public_path__ + "static/media/marketing-active.cd5f8c1b21dfc61a8e6165cc4dc88aa8.svg";
export { ForwardRef as ReactComponent };